var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-page",
    { staticClass: "admin" },
    [
      _c(
        "transition",
        { attrs: { name: "fade-fast", mode: "out-in", appear: "" } },
        [
          _vm.loading
            ? _c("d-loading")
            : _c("admin-" + _vm.component, {
                tag: "component",
                attrs: { post: _vm.post },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }